import React, { useContext } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import {
  FieldFormComponents,
  FormManagement,
} from "../../../utils/FormComponents/FormComponents";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
  } = useForm();
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = FormManagement(data);
      const response = await postData(
        `/admin/employee-management/general-manager`,
        finalData,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add General Manager
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <FieldFormComponents label="Full Name" error={errors?.name}>
                <Form.Control
                  type="text"
                  placeholder="Full name"
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                  {...register("name", {
                    required: "Full Name is required",
                    maxLength: {
                      value: 200,
                      message: "Max 200 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                      message: "Name should contain only letters and spaces",
                    },
                    validate: (value) =>
                      value.trim().length > 0 || "Full Name is required",
                  })}
                />
              </FieldFormComponents>

              <FieldFormComponents label="Contact No" error={errors.contact_no}>
                <Form.Control
                  type="text"
                  placeholder="Contact No"
                  maxLength={10}
                  className={classNames("", {
                    "is-invalid": errors?.contact_no,
                  })}
                  {...register("contact_no", {
                    required: "Mobile Number is required",
                    minLength: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                    maxLength: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Mobile number must be 10 digits",
                    },
                  })}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}
                />
              </FieldFormComponents>
              <FieldFormComponents label="Login Email" error={errors.email}>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  className={classNames("", { "is-invalid": errors?.email })}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                      message: "Invalid Email address",
                    },
                  })}
                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                  }}
                />
              </FieldFormComponents>
              <FieldFormComponents
                label={"Login Password"}
                error={errors.password}
              >
                <Form.Control
                  type="text"
                  placeholder="Login Password"
                  className={classNames("", {
                    "is-invalid": errors?.password,
                  })}
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/,
                      message:
                        "Password must contain uppercase, lowercase, number and special character",
                    },
                  })}
                />
              </FieldFormComponents>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
